import * as JsEncryptModule from 'jsencrypt';

/**
 * RSA 암호화만 가능한 유틸
 */
export class EncryptRSA {
  private _encrypt: any;

  constructor(publicKey: string) {
    this._encrypt = new JsEncryptModule.JSEncrypt();
    this._encrypt.setPublicKey(publicKey);
  }

  public encrypt(plainText: string): string {
    return this._encrypt.encrypt(plainText);
  }

}